import { render, staticRenderFns } from "./speedBack.vue?vue&type=template&id=7f4e1cf8&"
import script from "./speedBack.vue?vue&type=script&lang=js&"
export * from "./speedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports